// angular
import { Component } from '@angular/core';

// common
import { ISelfServContactInfo } from '@aa/common';

// local
import { AbstractQnaComponent } from '../abstract-qna.component';
import { QnaNavigationService } from '../qna-navigation.service';

interface IContactData {
  title: string;
  text: string;
}

@Component({
  selector: 'aa-qna-contact',
  templateUrl: './contact.component.html'
})
export class QnaContactPageComponent extends AbstractQnaComponent {

  readonly contact: ISelfServContactInfo;

  readonly items: IContactData[] = [];

  constructor(navigation: QnaNavigationService) {
    super(navigation, 'Contact');

    this.contact = this.meta.contact;

    if (!this.contact) {
      return;
    }
  }

  private addItem(title: string, text: string) {
    if (!text) {
      return;
    }

    this.items.push({title, text});
  }
}
